import { Map as MaplibreMap } from "maplibre-gl";
import type { GeoJSONSource } from "maplibre-gl";
import * as maplibreCSS from "maplibre-gl/dist/maplibre-gl.css?inline";
import { mapStyle } from "../lib/map-style";

const template = document.createElement("template");
template.innerHTML = `
	<style>
		${maplibreCSS}

		:host {
			display: block;
			width: 100%;
			height: 100%;
		}

		.map-container {
			width: 100%;
			height: 100%;
		}
	</style>
	<div class="map-container"></div>
`;

class MapView extends HTMLElement {
	static observedAttributes = ["latitude", "longitude"];

	private map: MaplibreMap | null = null;
	private container!: HTMLElement;

	constructor() {
		super();
		this.attachShadow({ mode: "open" });
		this.shadowRoot!.appendChild(template.content.cloneNode(true));
		this.container = this.shadowRoot!.querySelector(".map-container")!;
	}

	connectedCallback() {
		const lat = Number.parseFloat(this.getAttribute("latitude") ?? "0");
		const lng = Number.parseFloat(this.getAttribute("longitude") ?? "0");

		this.map = new MaplibreMap({
			container: this.container,
			style: mapStyle,
			center: [lng, lat],
			zoom: 14
		});

		this.map.on("load", () => {
			this.map!.addSource("user-location", {
				type: "geojson",
				data: {
					type: "Feature",
					geometry: {
						type: "Point",
						coordinates: [lng, lat]
					},
					properties: {}
				}
			});

			this.map!.addLayer({
				id: "user-location-outer",
				type: "circle",
				source: "user-location",
				paint: {
					"circle-radius": 14,
					"circle-color": "#e94560",
					"circle-stroke-width": 3,
					"circle-stroke-color": "#ffffff"
				}
			});

			this.map!.addLayer({
				id: "user-location-inner",
				type: "circle",
				source: "user-location",
				paint: {
					"circle-radius": 5,
					"circle-color": "#ffffff"
				}
			});
		});
	}

	disconnectedCallback() {
		this.map?.remove();
		this.map = null;
	}

	attributeChangedCallback(name: string, _oldValue: string, _newValue: string) {
		if (!this.map) {
			return;
		}

		const lat = Number.parseFloat(this.getAttribute("latitude") ?? "0");
		const lng = Number.parseFloat(this.getAttribute("longitude") ?? "0");

		if (name === "latitude" || name === "longitude") {
			const source = this.map.getSource("user-location") as GeoJSONSource | undefined;
			if (source) {
				source.setData({
					type: "Feature",
					geometry: {
						type: "Point",
						coordinates: [lng, lat]
					},
					properties: {}
				});
			}
			this.map.setCenter([lng, lat]);
		}
	}
}

customElements.define("map-view", MapView);
